import { render } from "./tableVirBody.vue?vue&type=template&id=d3558cdc"
import script from "./tableVirBody.vue?vue&type=script&lang=js"
export * from "./tableVirBody.vue?vue&type=script&lang=js"

import "./tableVirBody.vue?vue&type=style&index=0&id=d3558cdc&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__